portPattern